import { motion, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

/**
 * A wide band that fades what it holds, icon and text alike, sweeping across
 * it: the sign that something is running. A mask rather than a text shimmer,
 * because a shimmer paints through the text's own glyphs and cannot reach an
 * icon. Tuned by eye against the shimmer it replaces, so the two read alike.
 */
export const Glare = ({ children }: { children: ReactNode }) => {
  const stillness = useReducedMotion();
  return (
    <motion.span
      className="inline-flex"
      style={{
        maskImage:
          "linear-gradient(90deg, black 30%, rgba(0,0,0,0.1) 50%, black 70%)",
        maskSize: "250% 100%",
        maskRepeat: "no-repeat",
      }}
      initial={{ maskPosition: "100% 0%" }}
      animate={stillness ? undefined : { maskPosition: "0% 0%" }}
      transition={{
        repeat: Number.POSITIVE_INFINITY,
        duration: 3,
        ease: "linear",
      }}
    >
      {children}
    </motion.span>
  );
};
